'use client';
import { useEffect, useState } from 'react';

import { UiLandingFooterBioderma } from '@/fo/ui/landing/footer/bioderma';
import { UiLandingHeaderBioderma } from '@/fo/ui/landing/header/bioderma';
import {
  Navigation,
  UiLandingNavigationBioderma
} from '@/fo/ui/landing/navigation/bioderma';
import { Product } from '@/fo/ui/landing/product-card/bioderma';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { AcneProject } from '../components/AcneProject/AcneProject';
import { BuyNow } from '../components/BuyNow/BuyNow';
import { DiagnosticBanner } from '../components/DiagnosticBanner/DiagnosticBanner';
import { Efficiency } from '../components/Efficiency/Efficiency';
import { GammaProducts } from '../components/GammaProducts/GammaProducts';
import { HeroBanner } from '../components/HeroBanner/HeroBanner';
import { StepsProducts } from '../components/StepsProducts/StepsProducts';

import { styles } from './FeatureLandingPageBiodermaSebium.styles';

export interface FeatureLandingPageBiodermaSebiumProps {
  stepsProducts: Product[];
  gammaProducts: Product[];
  navigation: Navigation[];
  bgFooter: {
    sm: string;
    md: string;
  };
  footnotes?: Array<{
    id: string;
    content: React.ReactNode;
  }>;
}

export function FeatureLandingPageBiodermaSebium({
  navigation,
  bgFooter,
  footnotes,
  gammaProducts,
  stepsProducts
}: FeatureLandingPageBiodermaSebiumProps) {
  const slots = styles();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNearFooter, setIsNearFooter] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        setIsScrolled(scrollY > 100);
        setIsNearFooter(scrollY + windowHeight > documentHeight - 200);
        ticking = false;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={slots.base()}>
      <UiLandingHeaderBioderma
        progressColor="#00C389"
        recommendLogoSrc={staticMediaUrl(
          'landing/bioderma_sebium/logo-recommend.svg'
        )}
      />
      <div className="relative">
        <HeroBanner />
        <UiLandingNavigationBioderma
          className={slots.navigation({ isScrolled, isNearFooter })}
          classNameItem="whitespace-nowrap"
          items={navigation}
        />
      </div>

      <div className={slots.content()}>
        <picture>
          <source
            srcSet={staticMediaUrl(
              'landing/bioderma_sebium/main-bg_sm_new2.png'
            )}
            media="(max-width: 767px)"
          />
          <img
            className={slots.bg()}
            src={staticMediaUrl('landing/bioderma_sebium/main-bg_new4.jpg')}
            alt="SÉbium kerato+ гель-крем"
            width={1920}
            height={1080}
            fetchPriority="high"
          />
        </picture>
        <Efficiency />
        <StepsProducts stepsProducts={stepsProducts} />
        <AcneProject />
        {/* <Stories /> */}
        {/* <Prizes /> */}
        <DiagnosticBanner />
        <GammaProducts products={gammaProducts} />
        {footnotes && (
          <div className={slots.footnotes()}>
            {footnotes.map((footnote) => (
              <p
                key={footnote.id}
                className={slots.footnote()}
              >
                {footnote.content}
              </p>
            ))}
          </div>
        )}
      </div>

      <BuyNow isNearFooter={isNearFooter} />
      <UiLandingFooterBioderma bgFooter={bgFooter} />
    </div>
  );
}
